<template>
  <modal-fullscreen
    :visible="visible"
    class="settings-modal"
    title="Settings"
    :destroy-on-close="true"
    width="1100px"
    @cancel="closeModal"
  >
    <a-tabs v-model="activeKey" size="small" tabPosition="left">
      <a-tab-pane key="account">
        <span slot="tab" class="flex align-items-center gap-2">
          <a-icon icon="mdi:user" width="20px" height="20px" />
          Profile
        </span>
        <settings-account ref="profileRef" />
      </a-tab-pane>
      <a-tab-pane key="bookmarks">
        <span slot="tab" class="flex align-items-center gap-2">
          <a-icon icon="material-symbols:bookmark-outline" width="20px" height="20px" />
          Bookmarks
        </span>
        <settings-bookmarks />
      </a-tab-pane>
      <a-tab-pane key="company">
        <span slot="tab" class="flex align-items-center gap-2">
          <a-icon icon="mdi:user-group" width="20px" height="20px" />
          Companies
        </span>
        <settings-company />
      </a-tab-pane>
    </a-tabs>
    <template slot="footer">
      <a-button @click="closeModal">Close</a-button>
    </template>
  </modal-fullscreen>
</template>

<script>
import { Button, Tabs } from 'ant-design-vue'
import SettingsBookmarks from './settings-bookmarks.vue'
import SettingsCompany from './settings-company.vue'
import SettingsAccount from './settings-account.vue'

export default {
  components: {
    'a-tabs': Tabs,
    'a-tab-pane': Tabs.TabPane,
    'a-button': Button,
    'settings-bookmarks': SettingsBookmarks,
    'settings-company': SettingsCompany,
    'settings-account': SettingsAccount
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeKey: 'account'
    }
  },
  methods: {
    closeModal() {
      this.activeKey = 'account'
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.settings-modal ::v-deep .ant-modal-body {
  padding-left: 0;
  padding-right: 0;
}

.settings-modal ::v-deep .ant-tabs-tab {
  text-align: left !important;
}

.settings-modal ::v-deep .ant-tabs-content {
  height: 700px;
  overflow-y: auto;
  padding: 0 24px;
}

.settings-modal ::v-deep .ant-tabs-nav-scroll {
  width: 200px !important;
}

@media (max-width: 1024px) {
  .settings-modal ::v-deep .ant-tabs-content {
    height: 100%;
    overflow-y: auto;
    padding: 0 24px;
  }
}
</style>
